
const Alert = (props) => {

    return (
        <div className={` text-black text-sm text-left w-40 m-3 p-1 ${props.colorClass} rounded-lg`}>
        {props.message}
        </div>
    )
};

export default Alert;